addEventListener("DOMContentLoaded", _=>
[...document.getElementsByClassName("gallery")].forEach(gallery => {
    // nacteni dat
    let data = [];
    [...gallery.children].forEach(item => {
        data.push([item.href, item.children[0].src]);
        gallery.removeChild(item);
    });
    if(data.length==0) return;

    // velky obrazek
    let main = document.createElement("div");
    main.className = "main";
    main.style.backgroundImage = `url('${data[0][0]}')`;

// Zoom ovládání: pohyb myší, kolečko pro zoom a klik pro přepnutí
    main.dataset.zoom = 1;
    const setZoom = (z, e=null) => {
        z = Math.max(1, Math.min(4, Math.round(z*10)/10)); // 1.0 .. 4.0 step 0.1
        main.dataset.zoom = z;
        main.style.backgroundSize = z === 1 ? 'contain' : (z * 100) + '%';
        
        // Povolit scroll když není zoom, zablokovat když je zoom aktivní
        main.style.touchAction = z === 1 ? 'pan-y' : 'none';
        
        if (e) {
            const r = main.getBoundingClientRect();
            const x = (e.clientX - r.left) / r.width * 100;
            const y = (e.clientY - r.top) / r.height * 100;
            main.style.backgroundPosition = `${x}% ${y}%`;
        } else if (z === 1) {
            main.style.backgroundPosition = 'center';
        }
        main.style.cursor = z === 1 ? 'zoom-in' : 'zoom-out';
    }

    main.addEventListener('mousemove', e => {
        if (parseFloat(main.dataset.zoom) > 1) {
            const r = main.getBoundingClientRect();
            const x = (e.clientX - r.left) / r.width * 100;
            const y = (e.clientY - r.top) / r.height * 100;
            main.style.backgroundPosition = `${x}% ${y}%`;
        }
    });

    main.addEventListener('wheel', e => {
        e.preventDefault();
        const delta = e.deltaY > 0 ? -0.1 : 0.1;
        setZoom(parseFloat(main.dataset.zoom) + delta, e);
    }, { passive: false });

    main.addEventListener('click', e => {
        if (parseFloat(main.dataset.zoom) === 1) setZoom(2, e);
        else setZoom(1, e);
    });

    main.addEventListener('mouseenter', e => main.style.cursor = main.dataset.zoom === '1' ? 'zoom-in' : 'zoom-out');
    main.addEventListener('mouseleave', e => {
        if (main.dataset.zoom === '1') {
            main.style.backgroundSize = 'contain';
            main.style.backgroundPosition = 'center';
        }
    });

    // Touch support: pinch to zoom, double-tap to toggle, drag to pan 🔧
    main.style.touchAction = 'pan-y'; // Povolit vertikální scroll, dokud není zoom aktivní
    let touchState = {
        lastTap: 0,
        pinching: false,
        pinchStartDist: 0,
        pinchStartZoom: 1,
        pinchMidX: 0,
        pinchMidY: 0,
        panStartX: 0,
        panStartY: 0,
        panStartBgX: 50,
        panStartBgY: 50,
        isPanning: false
    };

    const getBgPosition = () => {
        let pos = main.style.backgroundPosition || '50% 50%';
        if (pos === 'center') pos = '50% 50%';
        const parts = pos.split(' ');
        const x = parseFloat(parts[0]);
        const y = parseFloat(parts[1]);
        return [isNaN(x) ? 50 : x, isNaN(y) ? 50 : y];
    };

    main.addEventListener('touchstart', e => {
        if (e.touches.length === 2) {
            touchState.pinching = true;
            const t0 = e.touches[0], t1 = e.touches[1];
            const dx = t1.clientX - t0.clientX, dy = t1.clientY - t0.clientY;
            touchState.pinchStartDist = Math.hypot(dx, dy);
            touchState.pinchStartZoom = parseFloat(main.dataset.zoom);
            touchState.pinchMidX = (t0.clientX + t1.clientX) / 2;
            touchState.pinchMidY = (t0.clientY + t1.clientY) / 2;
            e.preventDefault();
        } else if (e.touches.length === 1) {
            const t = e.touches[0];
            touchState.panStartX = t.clientX;
            touchState.panStartY = t.clientY;
            const [bgx, bgy] = getBgPosition();
            touchState.panStartBgX = bgx;
            touchState.panStartBgY = bgy;
            touchState.isPanning = parseFloat(main.dataset.zoom) > 1;

            const now = Date.now();
            if (now - touchState.lastTap <= 300) {
                // double-tap: toggle zoom
                if (parseFloat(main.dataset.zoom) === 1) setZoom(2, t);
                else setZoom(1, t);
                touchState.lastTap = 0;
                e.preventDefault();
            } else {
                touchState.lastTap = now;
                // Nevolat preventDefault() pokud není zoom - povolit normální scroll
            }
        }
    }, { passive: false });

    main.addEventListener('touchmove', e => {
        if (touchState.pinching && e.touches.length === 2) {
            const t0 = e.touches[0], t1 = e.touches[1];
            const dx = t1.clientX - t0.clientX, dy = t1.clientY - t0.clientY;
            const dist = Math.hypot(dx, dy);
            const scale = dist / touchState.pinchStartDist;
            setZoom(touchState.pinchStartZoom * scale, { clientX: touchState.pinchMidX, clientY: touchState.pinchMidY });
            e.preventDefault();
        } else if (touchState.isPanning && e.touches.length === 1) {
            // Panning jen když je zoom aktivní (isPanning je true jen když zoom > 1)
            const t = e.touches[0];
            const dx = t.clientX - touchState.panStartX;
            const dy = t.clientY - touchState.panStartY;
            const r = main.getBoundingClientRect();
            const newX = Math.max(0, Math.min(100, touchState.panStartBgX - dx / r.width * 100));
            const newY = Math.max(0, Math.min(100, touchState.panStartBgY - dy / r.height * 100));
            main.style.backgroundPosition = `${newX}% ${newY}%`;
            e.preventDefault();
        }
        // Pokud není pinching ani panning (zoom === 1), nevolat preventDefault - povolit scroll
    }, { passive: false });

    main.addEventListener('touchend', e => {
        if (touchState.pinching && e.touches.length < 2) {
            touchState.pinching = false;
        }
        if (parseFloat(main.dataset.zoom) === 1) {
            main.style.backgroundPosition = 'center';
            main.style.touchAction = 'pan-y'; // Obnovit scroll když není zoom
        }
    });

    main.addEventListener('touchcancel', e => {
        touchState.pinching = false;
        touchState.isPanning = false;
    });

    gallery.appendChild(main);
    if(data.length==1) return;

    // navigacni obrazky
    let navC = document.createElement("nav");
    gallery.appendChild(navC);
    let nav = [];
    let max = gallery.dataset.thumbs || 3;
    for(let i=0; i<Math.min(max,data.length); ++i) {
        let div = document.createElement("div");
        div.order = i;
        div.onclick = _=> { main.style.backgroundImage = `url('${data[div.order+index][0]}')`; setZoom(1); };
        nav.push(div);
        navC.appendChild(div);
    }

    // vyplneni navigace
    let index = 0;
    let fillImages = dir => {
        index+= dir;
        if(index<0) index = 0;
        let shift = Math.min(max,data.length);
        if(index>data.length-shift) index = data.length - max;
        for(let i=index; i<index+shift; ++i) nav[i-index].style.backgroundImage = data[i] ? `url('${data[i][1]}')` : 'none';
    }
    fillImages(0);
    if(data.length<=max) return;

    // sipky
    let arrR = document.createElement("div");
    arrR.innerHTML = `<span class="arrow-right"></span>`;
    nav[2].appendChild(arrR);
    let arrL = document.createElement("div");
    arrL.style.display = "none";
    nav[0].appendChild(arrL);

    // udalosti sipek
    let arrEvent = dir => e => {
        fillImages(3*dir);
        arrL.style.display = index > 0 ? "flex" : "none";
        arrL.innerHTML = `<span class="arrow-left"></span>`;
        arrR.style.display = index+3<data.length ? "flex" : "none";
        arrR.innerHTML = `<span class="arrow-right"></span>`;
        e.stopPropagation();
    }
    arrR.onclick = arrEvent(+1);
    arrL.onclick = arrEvent(-1);
}));
